import React from 'react';
import PropTypes from 'prop-types';

import Alert from '../../common/Alert';

const AdminErrorMessage = props => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className={props.className || 'mt-10px'}>
      <Alert message={props.message || 'An error occured'} isError />
    </div>
  );
};

AdminErrorMessage.propTypes = {
  isVisible: PropTypes.bool,
  className: PropTypes.string,
  message: PropTypes.string,
};

export default AdminErrorMessage;
